/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_9b4ac53d .ms-Suggestions-itemButton{padding:0px;border:none}.callout_9b4ac53d .ms-Suggestions{min-width:300px}\n"}]);
export const callout = "callout_9b4ac53d";